import { Link, useLocation } from "react-router-dom";
import { colors } from "../common/constants";

export default function Footer() {
  const location = useLocation();
  const isPlansPage = location.pathname === "/plans";

  return (
    <footer className="mt-16 mb-6 text-sm z-10 flex flex-col items-center">
      <div className="flex gap-4 mb-2">
        <Link to="/privacy" className="underline" style={{ color: colors.secondary }}>Privacy Policy</Link>
        <span style={{ color: colors.secondary }}>|</span>
        <Link to="/terms" className="underline" style={{ color: colors.secondary }}>Terms of Service</Link>
        {isPlansPage && (
          <>
            <span style={{ color: colors.secondary }}>|</span>
            <Link to="/refund" className="underline" style={{ color: colors.secondary }}>Refund Policy</Link>
          </>
        )}
      </div>
      <div style={{ color: colors.secondary }}>
        © {new Date().getFullYear()} Annotify — Take notes anywhere 🖊
      </div>
    </footer>
  );
}
